import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetOfferSources } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import {
  OfferSourceT,
  UseGetOfferSourcesFilters,
} from "../../../../domain/entities";

const RenderOption = ({ description }: OfferSourceT): React.ReactElement => {
  return (
    <section className="grid w-[300px] grid-flow-col items-center justify-between px-[5px] text-[12px]">
      <span>{description}</span>
    </section>
  );
};

const OfferSourcesSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "description",
  keyword,
  multiselect,
  required,
}: SelectComponentProps<OfferSourceT>): React.ReactElement => {
  return (
    <Select<OfferSourceT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      label={(option) => `${option.description}`}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
      required={required}
    />
  );
};

export const OfferSourceSelect = withSelectOptions<
  OfferSourceT,
  UseGetOfferSourcesFilters
>(OfferSourcesSelectComponent, useInfiniteGetOfferSources, "s");
